module.exports = __webpack_public_path__ + "static/media/Literaloka.7ad7f623.png";